module.exports = __webpack_public_path__ + "static/media/foto1.11651238.png";